import React, { useLayoutEffect } from "react";
import Drawer from "./navigation/sidebar";
import Appbar from "./navigation/appbar";
import Footer from "./navigation/footer";
import constData from "./../../utilities/const.json";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {

    const isMobile = window.innerWidth >= 992 ? false : true;
    const isAuthPage = ['/login', '/twofa', '/register'].includes(useLocation().pathname)

    return (
        <div>
            <ToastContainer />
            <Drawer>
                <div
                    className={`container not-logged-in`}
                    style={{
                        minHeight: isMobile
                            ? `calc(100dvh - ${constData.elementSize.MobileFooter} - ${constData.elementSize.MobileHeader} - ${constData.elementSize.MobileAppbar} - 16px)`
                            : `calc(100dvh - ${constData.elementSize.DesktopFooter} - ${constData.elementSize.DesktopHeader} - 16px)`,
                        marginTop: isMobile
                            ? `calc(${constData.elementSize.MobileHeader})`
                            : `calc(${constData.elementSize.DesktopHeader})`,
                    }}
                >
                    {children}
                </div>
                {!isAuthPage && <Footer />}
            </Drawer>
            {isMobile && <Appbar />}
        </div>
    );
};

export default Layout;
